// Data display conventions — design.md §9. All dates UTC.

const usd2 = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2 })
const usd0 = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 })
const num = new Intl.NumberFormat('en-US')

export const fmtUsd = (v: number) => usd2.format(v)
export const fmtUsdWhole = (v: number) => (Number.isInteger(v) ? usd0.format(v) : usd2.format(v))
export const fmtNum = (v: number) => num.format(v)

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

/** `12 Jun 2026` (UTC) */
export function fmtDate(iso: string | null | undefined): string {
  if (!iso) return '—'
  const d = new Date(iso)
  return `${d.getUTCDate()} ${MONTHS[d.getUTCMonth()]} ${d.getUTCFullYear()}`
}

/** `10 Jun 2026, 14:32 UTC` */
export function fmtDateTime(iso: string | null | undefined): string {
  if (!iso) return '—'
  const d = new Date(iso)
  const hh = String(d.getUTCHours()).padStart(2, '0')
  const mm = String(d.getUTCMinutes()).padStart(2, '0')
  return `${fmtDate(iso)}, ${hh}:${mm} UTC`
}

/** Relative time for in-table timestamps; pair with a tooltip showing fmtDateTime. */
export function fmtRelative(iso: string | null | undefined): string {
  if (!iso) return '—'
  const seconds = (Date.now() - new Date(iso).getTime()) / 1000
  if (seconds < 60) return 'just now'
  if (seconds < 3600) return `${Math.floor(seconds / 60)}m ago`
  if (seconds < 86_400) return `${Math.floor(seconds / 3600)}h ago`
  const days = Math.floor(seconds / 86_400)
  if (days === 1) return 'yesterday'
  if (days < 30) return `${days} days ago`
  return fmtDate(iso)
}

/** Hours until an ISO timestamp, floored at 0 — for "expires in 17h" badges. */
export function hoursUntil(iso: string): number {
  return Math.max(0, Math.floor((new Date(iso).getTime() - Date.now()) / 3_600_000))
}

/** YYYY-MM-DD (UTC) for date inputs / query params. */
export function toDateParam(d: Date): string {
  return d.toISOString().slice(0, 10)
}

const moneyFormats = new Map<string, Intl.NumberFormat>()

/** Integer cents in `currency` → `€1,234.50`. */
export function fmtMoney(minor: number, currency: string): string {
  let f = moneyFormats.get(currency)
  if (!f) {
    f = new Intl.NumberFormat('en-US', { style: 'currency', currency, minimumFractionDigits: 2 })
    moneyFormats.set(currency, f)
  }
  return f.format(minor / 100)
}

const MONTH_NAMES = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']

/** Billing Period `2026-10` → `October 2026`. */
export function fmtPeriod(period: string): string {
  const [y, m] = period.split('-').map(Number)
  return `${MONTH_NAMES[m - 1]} ${y}`
}
